<template>
	<v-row v-if="loading">
		<v-col cols="12" md="12" sm="12">
			<div  class="d-flex justify-content-center flex-column mt-16">
				<h4 class="text-center mx-auto">Cargando Widget... Espere por favor</h4>
				<br />
				<v-progress-circular
					:size="80"
					:width="7"
					color="primary"
					class="mx-auto"
					indeterminate
				></v-progress-circular>
			</div>
		</v-col>	
	</v-row>
	<documents-component v-else @reloadPresaleInfo="getPresaleFromCode" :is-presale="true"></documents-component>
</template>
  
<script>
import DocumentsComponent from "@/router/views/documents/index";
import { getQueryParamsFromPresale } from "@/helpers/presale";
import { mapActions } from "vuex";
  export default {
		data(){
			return {
				loading: true,
				codePresale: this.$route.query.code
			}
		},
    components: {
      DocumentsComponent,
    },
		mounted(){
			this.getPresaleFromCode()
		},
    methods: {
			...mapActions({
					getAllPresales: "presale/getAllPresales",
			}),
			async getPresaleFromCode(){
				let self = this
				let presalesData = await self.getAllPresales({
					general_filter: self.codePresale
				})
				if(presalesData?.preventas?.length){
					let currentPresale = presalesData.preventas[0]
					let presaleParams = getQueryParamsFromPresale(currentPresale)
					await self.$router.push({
						path: self.$route.path,
						query: {
							...self.$route.query,
							'presale_code': presaleParams.presale_code,
							'presale_name': presaleParams.presale_name,
							'presale_type': presaleParams.presale_type,
							'have_project': presaleParams.have_project,
							'approved_status': presaleParams.approved_status ?? undefined
						}
					});
				}
				self.loading = false
			}
    }
  };
  </script>
  
  <style></style>
  